<script>
import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import "vue-hotel-datepicker/dist/vueHotelDatepicker.css";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import errorHandler from "../../helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

/**
 * Rate Plan Component
 */
export default {
  data() {
    return {
      ratePlan: {
        name: "",
        short_name: "",
        start_date: "",
        end_date: "",
        dateRange: [],
        booking_source: [],
        plan_price: [],
        id: null,
      },
      submitted: false,
      errorMessage: null,
      is_btn_loading: false,
      bookingSources: [],
      roomTypes: [],
      isError: false,
      errorMessages: null,
      isSaveAndAddNew: false,
    };
  },
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit", "saveAndAddNew"],
  computed: {
    ...authComputed,
  },
  validations: {
    ratePlan: {
      name: {
        required,
      },
      short_name: {
        required,
      },
      dateRange: {
        required,
      },
      booking_source: {
        required,
      },
    },
  },
  async mounted() {
    await this.getBookingSources();
    await this.getRoomTypes();
    this.setIfEdit();
  },
  methods: {
    // Method is use for get all booking sources
    async getBookingSources() {
      await UserService.getBookingSourceList()
        .then((sources) => {
          sources.map((source) => {
            this.bookingSources.push({
              id: source.id,
              name: source.name,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for get all room types
    async getRoomTypes() {
      await UserService.getRoomTypeList()
        .then((room_types) => {
          room_types.map((room) => {
            this.roomTypes.push({
              room_type: room.id,
              name: room.name,
              Monday: room.std_rate,
              Tuesday: room.std_rate,
              Wednesday: room.std_rate,
              Thursday: room.std_rate,
              Friday: room.std_rate,
              Saturday: room.std_rate,
              Sunday: room.std_rate,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for set value on field
    setIfEdit() {
      if (this.currentProps.isEdit) {
        this.ratePlan.name = this.currentProps.selectedRatePlan.name;
        this.ratePlan.short_name =
          this.currentProps.selectedRatePlan.short_name;
        this.ratePlan.dateRange = [
          this.currentProps.selectedRatePlan.start_date,
          this.currentProps.selectedRatePlan.end_date,
        ];
        this.ratePlan.start_date =
          this.currentProps.selectedRatePlan.start_date;
        this.ratePlan.end_date = this.currentProps.selectedRatePlan.end_date;
        this.ratePlan.booking_source =
          this.currentProps.selectedRatePlan.booking_source;
      }
    },
    // Method is use for update and save data
    onSubmit() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        const bookingSourceId = [];
        this.ratePlan.booking_source.map((item) => {
          bookingSourceId.push(item.id);
        });

        const data = {
          name: this.ratePlan.name,
          short_name: this.ratePlan.short_name,
          start_date: moment(this.ratePlan.dateRange[0]).format("YYYY-MM-DD"),
          end_date: moment(this.ratePlan.dateRange[1]).format("YYYY-MM-DD"),
          booking_source: bookingSourceId,
        };

        if (this.currentProps.isEdit == false) {
          if (this.ratePlan.plan_price.length == 0) {
            Middleware.notification(
              "Select at least one room type !!",
              "error"
            );

            this.is_btn_loading = false;
            return;
          }
          data.hotel = this.hotel.id;
          data.plan_price = [];
          this.ratePlan.plan_price.map((price) => {
            let temp_price = price;
            data.plan_price.push(temp_price);
          });
          UserService.createRatePlan(data).then(
            (ratePlan) => {
              if (!this.isSaveAndAddNew) {
                this.$emit("submitted", ratePlan);
              } else {
                this.$emit("saveAndAddNew", ratePlan);
              }
              this.is_btn_loading = false;
              this.submitted = false;
            },
            (error) => {
              errorHandler(error);
              this.is_btn_loading = false;
              this.isError = true;

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessages = error.response.data.non_field_errors;
              } else {
                this.errorMessages = error.response.data;
              }
            }
          );
        } else {
          UserService.editRatePlan(
            data,
            this.currentProps.selectedRatePlan.id
          ).then(
            (response) => {
              this.$emit("submitted", response);
              this.is_btn_loading = false;
              this.submitted = false;
            },
            (error) => {
              errorHandler(error);
              this.is_btn_loading = false;
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessages = error.response.data.non_field_errors;
              } else {
                this.errorMessages = error.response.data;
              }
            }
          );
        }
      }
    },
    // Method is use for save and add new guest continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is use for cancel to add new guest
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    // Method is use to handle date
    updateDate(date) {
      if (date[0] !== null) {
        this.ratePlan.dateRange = date;
      } else {
        this.ratePlan.dateRange = [];
      }
    },
    // Method is use for update all data value for particular room type
    changeAll(event, index) {
      if (event.target.value) {
        this.roomTypes[index].Monday = event.target.value;
        this.roomTypes[index].Tuesday = event.target.value;
        this.roomTypes[index].Wednesday = event.target.value;
        this.roomTypes[index].Thursday = event.target.value;
        this.roomTypes[index].Friday = event.target.value;
        this.roomTypes[index].Saturday = event.target.value;
        this.roomTypes[index].Sunday = event.target.value;
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>
          {{
            this.currentProps.isEdit ? "Update Rate Plan" : "Add New Rate Plan"
          }}
        </h4>
        <h4 v-if="isError">
          <template v-if="typeof errorMessages == 'object'">
            <span v-for="error in errorMessages" :key="error">
              <span class="badge card-badge badge-soft-danger">
                <b>{{ error.replace("The fields hotel,", "") }}</b>
              </span>
              <br />
            </span>
          </template>
          <template v-else>
            <span class="badge card-badge badge-soft-danger">
              <b>{{ errorMessages }}</b>
            </span>
          </template>
        </h4>
        <hr />
      </div>
      <div class="col-md-6">
        <b-form-group
          class="mb-3"
          label="Name"
          label-for="rate-plan-name-input"
        >
          <template slot="label">
            Rate Plan Name <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="rate-plan-name-input"
            type="text"
            autocomplete="off"
            placeholder="Like : Crismistmas Special"
            v-model="ratePlan.name"
            :class="{
              'is-invalid': submitted && $v.ratePlan.name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.ratePlan.name.required"
              >rate plan name is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group
          class="mb-3"
          label="Short Name"
          label-for="rate-plan-short-name-input"
        >
          <template slot="label">
            Rate Plan Short Name
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="rate-plan-short-name-input"
            type="text"
            autocomplete="off"
            placeholder="Like : Santa Gift"
            v-model="ratePlan.short_name"
            :class="{
              'is-invalid': submitted && $v.ratePlan.short_name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.ratePlan.short_name.required"
              >Rate plan short name is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <label
          >Select Start and End Date <span class="text-danger">*</span></label
        >
        <date-picker
          lang="en"
          placeholder="Select date to stay"
          range
          type="date"
          value-type="format"
          v-model="ratePlan.dateRange"
          @change="updateDate"
          :class="{
            'is-invalid': submitted && $v.ratePlan.dateRange.$error,
          }"
        ></date-picker>
        <div v-if="submitted" class="invalid-feedback">
          <span v-if="!$v.ratePlan.dateRange.required"
            >rate plan start date and end date is required.</span
          >
        </div>
      </div>
      <div class="col-md-6">
        <label>Select Booking Sources <span class="text-danger">*</span></label>
        <multiselect
          v-model="ratePlan.booking_source"
          :options="bookingSources"
          track-by="id"
          label="name"
          :multiple="true"
          :class="{
            'is-invalid': submitted && $v.ratePlan.booking_source.$error,
          }"
          :show-labels="false"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            {{ option.name }}
          </template>
        </multiselect>
        <div v-if="submitted" class="invalid-feedback">
          <span v-if="!$v.ratePlan.booking_source.required"
            >select at least one booking source.</span
          >
        </div>
      </div>
    </div>
    <hr v-if="currentProps.isEdit == false" />
    <div class="row" v-if="currentProps.isEdit == false">
      <div class="col-lg-12">
        <h4 class="card-title">Room Type Data</h4>

        <div class="table-responsive">
          <table class="table mb-0">
            <thead class="table-light">
              <tr>
                <th>Room Type</th>
                <th>Mon</th>
                <th>Tue</th>
                <th>Wed</th>
                <th>Thu</th>
                <th>Fri</th>
                <th>Sat</th>
                <th>Sun</th>
                <th>All Days</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(room, index) in roomTypes" :key="index">
                <th>
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    id="horizontalLayout-Check"
                    :value="room"
                    v-model="ratePlan.plan_price"
                  />{{ room.name }}
                </th>
                <td>
                  <b-form-input
                    type="number"
                    class="px-2"
                    autocomplete="off"
                    v-model="room.Monday"
                  ></b-form-input>
                </td>
                <td>
                  <b-form-input
                    type="number"
                    class="px-2"
                    autocomplete="off"
                    v-model="room.Tuesday"
                  ></b-form-input>
                </td>
                <td>
                  <b-form-input
                    type="number"
                    class="px-2"
                    autocomplete="off"
                    v-model="room.Wednesday"
                  ></b-form-input>
                </td>
                <td>
                  <b-form-input
                    type="number"
                    class="px-2"
                    autocomplete="off"
                    v-model="room.Thursday"
                  ></b-form-input>
                </td>
                <td>
                  <b-form-input
                    type="number"
                    class="px-2"
                    autocomplete="off"
                    v-model="room.Friday"
                  ></b-form-input>
                </td>
                <td>
                  <b-form-input
                    type="number"
                    class="px-2"
                    autocomplete="off"
                    v-model="room.Saturday"
                  ></b-form-input>
                </td>
                <td>
                  <b-form-input
                    type="number"
                    class="px-2"
                    autocomplete="off"
                    v-model="room.Sunday"
                  ></b-form-input>
                </td>
                <td>
                  <b-form-input
                    type="number"
                    autocomplete="off"
                    @blur="changeAll($event, index)"
                    class="px-2"
                  ></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel</b-button
        >
        <b-button
          v-if="this.currentProps.isEdit === false"
          class="float-end ms-2"
          variant="outline-primary"
          type="submit"
          @click="saveAndAddNew"
          :class="{
            disabled: isSaveAndAddNew === true && is_btn_loading,
          }"
        >
          <i
            v-if="isSaveAndAddNew === true && is_btn_loading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i
          >Save & Add</b-button
        >
        <b-button
          class="float-end"
          variant="outline-primary"
          type="submit"
          @click="onSubmit"
          :class="{
            disabled: isSaveAndAddNew === false && is_btn_loading,
          }"
        >
          <i
            v-if="isSaveAndAddNew === false && is_btn_loading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          {{ currentProps.isEdit ? "Update" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>
